module.exports = __webpack_public_path__ + "static/media/closeIcon.1e348cf2.svg";